import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import AclContextProvider from '../../../../Modules/Acl/Components/AclContextProvider';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import NcziManager from './NcziManager';

loadDOMComponent({
	selector: 'react-nczi-manager',
	callback: ({ container, context, props }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<NcziManager />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
